import { EUserUrls } from 'data/urls/user.url';
import { TUserAdminDB, TUserPropertyManagerDB, TUserTypeDataDB } from 'data/types/user.types';
import {
  userAdminConverter,
  userPropertyManagerConverter,
  userTypeDataConverter,
} from 'data/converters/user.converters';
import { EPropertyMangerUrl } from 'data/urls/propertyManager.url';
import { EAdminUrl } from 'data/urls/admin.url';
import { EAuthUrls } from 'data/urls/auth.url';
import { userPermissionsFromDb } from 'data/converters/permissionSets.converters';
import { BaseQuery, QueryReturnValue } from '../store';

export const getUserTypeDataService = async (baseQuery: BaseQuery) => {
  const userTypeData = (await baseQuery(
    `${EPropertyMangerUrl.PROPERTY_MANAGER}/${EAuthUrls.AUTH}/${EAuthUrls.LOGIN}`
  )) as QueryReturnValue<TUserTypeDataDB>;
  return userTypeData.data ? userTypeDataConverter.fromDb(userTypeData.data) : null;
};

export const getAdminUserService = async (baseQuery: BaseQuery) => {
  const responseData = (await baseQuery(`${EAdminUrl.ADMIN}/${EUserUrls.PROFILE}`)) as QueryReturnValue<TUserAdminDB>;
  return responseData.data ? userAdminConverter.fromDb(responseData.data) : null;
};

export const getPropertyManagerUserService = async (baseQuery: BaseQuery) => {
  const responseData = (await baseQuery(
    `${EPropertyMangerUrl.PROPERTY_MANAGER}/${EUserUrls.PROFILE}`
  )) as QueryReturnValue<TUserPropertyManagerDB>;
  if (!responseData.data) return null;
  const user = userPropertyManagerConverter.fromDb(responseData.data);
  if (responseData.data.permissions) {
    user.permissions = userPermissionsFromDb(responseData.data.permissions);
  }
  return user;
};

export const impersonateUser = async (baseQuery: BaseQuery, id?: string | null) => {
  const responseData = (await baseQuery({
    url: `${EAdminUrl.ADMIN}/${EUserUrls.PROFILE}/${EUserUrls.IMPERSONATION}`,
    method: 'POST',
    body: { userId: id },
  })) as QueryReturnValue<{ name: string; userId: string }>;
  return responseData.data ? responseData.data : null;
};
